import React, { useState } from "react";
import { 
  EditOptionContainer, 
  EditOptionTitle, 
  EditOptionDescription, 
  FormGroup, 
  Button, 
  ButtonGroup,
  LoadingSpinner,
  InputSlider
} from "../EditOptionStyles";
import { blurBackground } from "../../utils/editUtils";

const BlurBackground = ({ onSubmit, isLoading }) => {
  const [scale, setScale] = useState(3);
  
  const handleSubmit = () => {
    // Pass the editType, options, and apiFunction to the parent
    onSubmit({
      editType: "blurBackground",
      options: {
        scale: scale // Pass scale directly without conversion
      },
      apiFunction: blurBackground
    });
  };

  return (
    <EditOptionContainer>
      <div>
        <EditOptionTitle icon="🔍">Blur Background</EditOptionTitle>
        <EditOptionDescription>
          Keep your subject in focus by intelligently blurring the background for a professional depth-of-field effect.
        </EditOptionDescription>
      </div>

      <FormGroup label="Blur Intensity">
        <InputSlider 
          value={scale} 
          onChange={(e) => setScale(parseInt(e.target.value))} 
          min={1} 
          max={5} 
          step={1}
        />
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          fontSize: "0.75rem", 
          color: "#888",
          marginTop: "0.25rem" 
        }}>
          <span>Subtle</span>
          <span>Strong</span>
        </div>
      </FormGroup>

      <ButtonGroup>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <LoadingSpinner />
              Processing...
            </>
          ) : (
            "Apply Blur"
          )}
        </Button>
      </ButtonGroup>
    </EditOptionContainer>
  );
};

export default BlurBackground;